import { useEffect, useState } from "react";
import api from "@/lib/api";

export function usePartnerMeta() {
  const [meta, setMeta] = useState(null);
  const reload = () => api.get("/partners/me").then((r) => setMeta(r.data)).catch(() => setMeta({ perms: [], config: {}, pipelines: [], users: [] }));
  useEffect(() => { reload(); }, []);
  return [meta, reload];
}

export const can = (meta, a) => !!meta?.perms?.includes(a);
export const today = () => new Date().toISOString().slice(0, 10);
export const STATUS_STYLE = { "En cours": "bg-sky-100 text-sky-800", Actif: "bg-emerald-100 text-emerald-800", Suspendu: "bg-amber-100 text-amber-800",
  Terminé: "bg-slate-200 text-slate-700", Archivé: "bg-slate-100 text-slate-500", "À faire": "bg-slate-100 text-slate-700", Réalisée: "bg-emerald-100 text-emerald-800",
  Reportée: "bg-amber-100 text-amber-800", Annulée: "bg-rose-100 text-rose-700", Gagnée: "bg-emerald-100 text-emerald-800", Perdue: "bg-rose-100 text-rose-700",
  Signé: "bg-emerald-100 text-emerald-800", "En préparation": "bg-slate-100 text-slate-700", Envoyé: "bg-sky-100 text-sky-800", Expiré: "bg-rose-100 text-rose-700", Résilié: "bg-rose-100 text-rose-700" };
export const Pill = ({ s }) => <span className={`inline-block rounded-full px-2 py-0.5 text-[11px] font-semibold whitespace-nowrap ${STATUS_STYLE[s] || "bg-slate-100"}`}>{s}</span>;
